import type { Dict } from "../lib/i18n";

// Keys are prefixed "ledger." — keep zh / en / nl in step.
export default {
  zh: {
    "ledger.labels.title": "给这次买的食品拍营养表",
    "ledger.labels.hint": "包装食品拍一下背面的营养成分表，热量、糖、脂肪、盐就存进食材库，以后做饭、算健康都用得上。",
    "ledger.labels.shoot": "拍营养表",
    "ledger.labels.done": "已有营养数据",
    "ledger.labels.saved": "营养数据和照片已存进食材库",
    "ledger.trend.more": "上个月比前一个月多花了 {amount}（+{pct}%）",
    "ledger.trend.less": "上个月比前一个月少花了 {amount}（−{pct}%），省下来了！",
    "ledger.trend.legend": "橙色点：比前一个月多花；绿色点：比前一个月少花。",
    "ledger.trend.saved": "这 12 个月省下了 {amount}",
    "ledger.trend.savedHint": "省下的钱 = 小票上的折扣 + 退瓶拿回的钱。",
    "ledger.savedToPantry": "已记账，{n} 样食品已放进食材库。包装食品可以拍营养表 →",
    "ledger.ocr.intro": "在手机上识别小票：商家、日期、金额和每一行商品，免费，照片不离开手机。保存前请核对一遍。",
    "ledger.ocr.read": "识别小票",
    "ledger.ocr.reading": "正在识别小票… {pct}%",
    "ledger.ocr.done": "已根据小票填好，请核对金额、日期和商家。",
    "ledger.pantry.on": "同时放进食材库：{names}等 {n} 样",
    "ledger.pantry.off": "不放进食材库",
    "ledger.pantry.toggle": "保存时把小票上的食品放进食材库",
    "ledger.pantry.choose": "选哪些放进去",
    "ledger.seePantry": "看食材库",
    "ledger.oneReceipt": "一张小票，保存一次：记进账本 · 勾掉购物清单里买到的 · 食品放进食材库。",
    "ledger.detail.pantry": "放进了食材库",
    "ledger.detail.pantryLeft": "还剩 {n}",
    "ledger.detail.pantryGone": "已用完",
    "ledger.ocr.retake": "重拍一张",
    "ledger.ocr.aiFilling": "AI 正在补充手机没读清的金额和商品…你可以先核对、修改或直接保存。",
    "ledger.ocr.items": "{n} 件商品",
    "ledger.ocr.sumOk": "商品加起来和总额一致。",
    "ledger.ocr.saveHint": "没问题就直接点下面的“保存”。",
    "ledger.ocr.unreadable": "这张照片没认出小票上的字。请拍正、拍亮一点再试，或者直接填写下面的内容。",
    "ledger.fileBy.label": "归档方式",
    "ledger.fileBy.date": "按日期",
    "ledger.fileBy.store": "按商家",
    "ledger.fileBy.count": "{n} 张",
    "ledger.plan.title": "计划内还是计划外",
    "ledger.plan.planned": "清单上计划要买的",
    "ledger.plan.discount": "清单上的促销商品",
    "ledger.plan.extra": "临时加的（计划外）",
    "ledger.plan.offList": "不在清单上的",
    "ledger.plan.saved": "小票上的折扣一共省了 {amount}。",
    "ledger.plan.basis": "只统计对照过购物清单的 {n} 张小票。",
    "ledger.guide.unplanned": "这个月有 {amount}（{percent}%）花在计划外的东西上。出门前把要买的写进清单，能省下不少。",
    "ledger.items.type": "第 {n} 行的类型",
    "ledger.deposit.action": "退瓶退款",
    "ledger.deposit.formTitle": "记一笔退瓶退款",
    "ledger.deposit.intro": "填上退瓶小票的金额和超市就行。它算作退款，会从本月支出里扣掉。",
    "ledger.form.more": "更多（付款方式、明细、备注…）",
    "ledger.form.moreItems": "{n} 项明细",
    "ledger.match.linkedSummary": "已对照购物清单 {n} 样 · 修改",
    "ledger.match.collapsed": "对照购物清单 · 选填",
    "ledger.match.empty": "购物清单上暂时没有可以对照的商品。",
    "ledger.ai.unavailable": "AI 识别暂时用不了，请直接填写下面的金额和商家。",
    "ledger.ai.fillManually": "请直接填写下面的内容。",
    "ledger.items.addReturn": "退瓶退款",
    "ledger.line.item": "商品",
    "ledger.line.deposit": "瓶子押金",
    "ledger.line.deposit_return": "退瓶退款",
    "ledger.line.discount": "折扣",
    "ledger.deposit.paid": "瓶子押金 {amount}",
    "ledger.deposit.returned": "退瓶退款 −{amount}",
    "ledger.match.title": "对照购物清单",
    "ledger.match.hint": "勾选这张小票上买到的清单商品，它们会自动打勾，并和这张小票关联。",
    "ledger.match.summary": "买到了 {bought} 样 · 清单上还没买 {open} 样",
    "ledger.match.unplanned": "小票上有、清单上没有的（计划外）：",
    "ledger.match.boughtEarlier": "已在清单上打勾",
    "ledger.match.onReceipt": "购物清单里的这些东西",
    "ledger.match.openList": "打开清单",
    "ledger.ins.deposits": "退瓶退款",
    "ledger.ins.depositsSub": "本月付了瓶子押金 {paid}",
    "ledger.title": "家庭账本",
    "ledger.tab.records": "账目",
    "ledger.tab.insights": "分析",
    "ledger.spent": "支出",
    "ledger.income": "收入",
    "ledger.balance": "结余",
    "ledger.scan": "拍小票",
    "ledger.manual": "手动记一笔",
    "ledger.addRecord": "记一笔",
    "ledger.listLabel": "账目",
    "ledger.search": "搜索商家、商品或备注",
    "ledger.filters": "筛选",
    "ledger.clearFilters": "清除筛选",
    "ledger.clearSearch": "清除搜索和筛选",
    "ledger.hasPhoto": "有照片",
    "ledger.view": "查看",
    "ledger.savedToast": "已记下",

    "ledger.month.prev": "上个月",
    "ledger.month.next": "下个月",
    "ledger.month.pick": "{month}，选择月份",
    "ledger.month.title": "选择月份",
    "ledger.month.count": "{n} 笔",
    "ledger.month.count.one": "1 笔",
    "ledger.month.none": "没有记录",

    "ledger.scope.month": "{month}共 {n} 笔",
    "ledger.scope.month.one": "{month}共 1 笔",
    "ledger.scope.all": "所有月份共 {n} 笔",
    "ledger.scope.all.one": "所有月份共 1 笔",
    "ledger.scope.searchAll": "搜索所有月份",
    "ledger.scope.onlyMonth": "只看本月",

    "ledger.empty.title": "{month}还没有记录",
    "ledger.empty.body": "拍一张小票，或者手动记一笔现金消费，就可以开始了。",
    "ledger.empty.noMatch": "没有找到相符的记录",
    "ledger.empty.noMatchHint": "试试搜索所有月份，或者放宽筛选条件。",

    "ledger.kind.expense": "支出",
    "ledger.kind.refund": "退款",
    "ledger.kind.income": "收入",
    "ledger.kindPlural.expense": "支出",
    "ledger.kindPlural.refund": "退款",
    "ledger.kindPlural.income": "收入",
    "ledger.pay.card": "刷卡",
    "ledger.pay.cash": "现金",
    "ledger.pay.transfer": "转账",
    "ledger.photo.with": "有照片",
    "ledger.photo.without": "没有照片",
    "ledger.trend.title": "近 12 个月的花费曲线",
    "ledger.trend.all": "全部支出",
    "ledger.trend.total": "{what}：12 个月共 {amount}，平均每月 {avg}",
    "ledger.trend.goods": "买回家的东西（衣服、日用品、工具…）在“家庭物品库”里按种类看",
    "ledger.trip.title": "本次购物怎么算",
    "ledger.health.title": "这次买的食品健不健康",
    "ledger.health.scoreLabel": "健康分",
    "ledger.health.explain": "买食品的钱里，有 {score}% 花在不高糖、不高盐、不高脂的食物上（按每 100 克的常见含量）。",
    "ledger.health.sugar": "高糖",
    "ledger.health.salt": "高盐",
    "ledger.health.fat": "高脂",
    "ledger.health.unknown": "还有 {n} 样正在识别，稍后再看会更完整。",
    "ledger.trip.goods": "商品",
    "ledger.trip.deposit": "瓶子押金",
    "ledger.trip.returned": "退瓶（小票上）",
    "ledger.trip.discount": "折扣",
    "ledger.trip.paid": "小票实付",
    "ledger.trip.voucher": "退瓶券",
    "ledger.trip.real": "本次实际花费",
    "ledger.trip.voucherLink": "退瓶券 {date} {amount}",
    "ledger.trip.hint": "退瓶的钱抵扣这次购物的支出；月度合计里也已经扣掉了，不会算两次。",
    "ledger.trip.usedOn": "这张退瓶券抵扣了 {date} 在 {store} 的购物：小票 {paid} → 实际花费 {real}",

    "ledger.cat.groceries": "买菜日用",
    "ledger.cat.dining": "餐饮外卖",
    "ledger.cat.home": "家居用品",
    "ledger.cat.housing": "住房",
    "ledger.cat.utilities": "水电网费",
    "ledger.cat.transport": "交通",
    "ledger.cat.health": "医疗健康",
    "ledger.cat.education": "教育",
    "ledger.cat.leisure": "休闲娱乐",
    "ledger.cat.clothing": "服饰鞋包",
    "ledger.cat.other": "其他",

    "ledger.form.newTitle.expense": "记一笔支出",
    "ledger.form.newTitle.refund": "记一笔退款",
    "ledger.form.newTitle.income": "记一笔收入",
    "ledger.form.editTitle": "编辑记录",
    "ledger.form.photo": "小票照片",
    "ledger.form.scanHint": "先拍下小票，App 会读出店名、日期、金额和每样商品；也可以直接手动填写。",

    "ledger.ai.intro": "让 AI 读出商家、日期、金额和商品明细。保存前请你核对一遍。",
    "ledger.ai.read": "用 AI 识别小票",
    "ledger.ai.reading": "正在识别小票…",
    "ledger.ai.done": "已根据小票填好，请核对。",
    "ledger.ai.notEuro": "这张小票的币种是 {currency}，不是欧元，所以没有填金额。请自己填写欧元金额。",

    "ledger.field.kind": "类型",
    "ledger.field.amount": "金额",
    "ledger.field.date": "日期",
    "ledger.field.store": "商家 / 收款方",
    "ledger.field.storePh": "例如 Albert Heijn",
    "ledger.field.source": "付款方 / 收入来源",
    "ledger.field.sourcePh": "例如 工资、补贴",
    "ledger.field.category": "分类",
    "ledger.field.categoryAuto": "根据名称自动推荐，可以改。",
    "ledger.field.payment": "支付方式",
    "ledger.field.essential": "必要开销",
    "ledger.field.essentialHint": "房租、买菜、保险这类省不了的钱。",
    "ledger.field.recurring": "固定支出",
    "ledger.field.recurringHint": "每个月都会有，比如订阅和会员费。",
    "ledger.field.reference": "单号",
    "ledger.field.referenceHint": "小票上的单号或编号",
    "ledger.field.notes": "备注",

    "ledger.items.title": "商品明细",
    "ledger.items.name": "第 {n} 项商品",
    "ledger.items.namePh": "商品名称",
    "ledger.items.price": "第 {n} 项的价格",
    "ledger.items.remove": "删除第 {n} 项",
    "ledger.items.add": "添加商品",
    "ledger.items.sum": "明细合计 {amount}",
    "ledger.items.diff": "和总金额相差 {amount}",
    "ledger.items.useSum": "用作总金额",
    "ledger.items.total": "明细合计",

    "ledger.err.amount.required": "请填写金额。",
    "ledger.err.amount.invalid": "请填写正确的金额，例如 12.50。",
    "ledger.err.amount.zero": "金额必须大于零。",
    "ledger.err.amount.too_large": "金额不能超过 100 万欧元。",
    "ledger.err.date.required": "请选择日期。",
    "ledger.err.date.invalid": "这个日期不存在。",
    "ledger.err.date.future": "日期不能晚于今天。",
    "ledger.err.store.required": "请填写商家或收款方。",
    "ledger.err.store.too_long": "最多 120 个字符。",
    "ledger.err.item_name": "有价格的商品也要填写名称。",
    "ledger.err.item_price": "请检查商品价格，例如 2.49。",
    "ledger.err.fix": "请先修改标出的内容。",

    "ledger.review.title": "保存前请确认一下",
    "ledger.review.duplicate": "已经有一笔商家、日期、类型和金额都相同的记录。",
    "ledger.review.same_photo": "这张照片已经用在另一笔记录里了。",
    "ledger.review.items_mismatch": "商品明细加起来和总金额对不上。",
    "ledger.review.body": "如果确认没问题，仍然可以保存。",
    "ledger.review.check": "返回检查",
    "ledger.review.saveAnyway": "仍然保存",

    "ledger.detail.title": "记录详情",
    "ledger.detail.inTrash": "这笔记录在回收站里。",
    "ledger.detail.photo": "照片",
    "ledger.detail.enlarge": "放大照片",
    "ledger.detail.photoAlt": "{store} 的小票",
    "ledger.detail.openPhoto": "查看原图",
    "ledger.detail.created": "{when}添加",
    "ledger.detail.updated": "{when}修改",
    "ledger.detail.trash": "移到回收站",

    "ledger.trash.title": "回收站",
    "ledger.trash.link": "回收站",
    "ledger.trash.intro": "回收站里的记录不计入统计。你可以恢复，也可以永久删除。",
    "ledger.trash.empty": "回收站是空的",
    "ledger.trash.restored": "「{store}」已恢复",
    "ledger.trash.deleted": "已永久删除",
    "ledger.trash.confirmTitle": "永久删除？",
    "ledger.trash.confirmBody": "「{store}」和它的照片会被彻底删除，无法找回。",

    "ledger.export.title": "导出",
    "ledger.export.intro": "把账目下载成表格。Excel 文件里还有按月份、商家和分类的汇总。",
    "ledger.export.xlsxAll": "Excel · 全部记录",
    "ledger.export.xlsxMonth": "Excel · {month}",

    "ledger.quarter.title": "季度总览",
    "ledger.quarter.pick": "季度",
    "ledger.quarter.label": "{year}年第{q}季度",
    "ledger.quarter.empty": "{quarter}没有记录",
    "ledger.quarter.months": "各月份",
    "ledger.quarter.export": "下载本季度 Excel",
    "ledger.quarter.ready": "上季度的总结出来了",
    "ledger.quarter.readySub": "看看{quarter}的钱都花在了哪里。",

    "ledger.ins.metrics": "本月概况",
    "ledger.ins.net": "净支出",
    "ledger.ins.refundsIncluded": "已扣除退款 {amount}",
    "ledger.ins.noIncomeYet": "还没有记录收入",
    "ledger.ins.vsPrev": "比上个月",
    "ledger.ins.prevWas": "上个月 {amount}",
    "ledger.ins.noPrev": "上个月没有记录",
    "ledger.ins.records": "记录数",
    "ledger.ins.withPhoto": "有照片的",
    "ledger.ins.guidance": "本月小提示",
    "ledger.ins.categories": "钱花在了哪里",
    "ledger.ins.merchants": "按商家",
    "ledger.ins.times": "{n} 次",
    "ledger.ins.times.one": "1 次",
    "ledger.ins.through": "月内分布",
    "ledger.ins.days": "{from}–{to} 日",
    "ledger.ins.emptyTitle": "{month}还没有记录",
    "ledger.ins.emptyBody": "记上几笔，就能看到钱都花在哪里。",

    "ledger.budget.title": "预算",
    "ledger.budget.set": "设置预算",
    "ledger.budget.edit": "修改",
    "ledger.budget.none": "本月还没有预算。设一个支出上限，随时看看花了多少。",
    "ledger.budget.used": "已用 {percent}%",
    "ledger.budget.over": "超出预算 {amount}",
    "ledger.budget.left": "还可以花 {amount}",
    "ledger.budget.reserve": "必要开销预留",
    "ledger.budget.essentialSpent": "必要开销已花 {amount}",
    "ledger.budget.savings": "储蓄目标",
    "ledger.budget.savingsNoIncome": "记录收入后才能跟踪",
    "ledger.budget.savingsOk": "进展顺利",
    "ledger.budget.savingsShort": "还差 {amount}",
    "ledger.budget.sheetTitle": "{month}预算",
    "ledger.budget.intro": "设定这个月最多想花多少钱。预留部分是留给必要开销的。",
    "ledger.budget.fromPrev": "已按上个月的预算填好。",
    "ledger.budget.ceiling": "支出上限",
    "ledger.budget.ceilingHint": "这个月最多想花的钱。",
    "ledger.budget.reserveHint": "上限中留给房租、买菜等必要开销的部分。",
    "ledger.budget.savingsHint": "希望从收入中存下来的钱。",
    "ledger.budget.remove": "删除预算",
    "ledger.budget.err.ceiling_required": "请填写支出上限。",
    "ledger.budget.err.ceiling_invalid": "上限必须大于零，且不超过 100 万欧元。",
    "ledger.budget.err.reserve_invalid": "请检查预留金额。",
    "ledger.budget.err.reserve_exceeds": "预留金额不能超过支出上限。",
    "ledger.budget.err.savings_invalid": "请检查储蓄金额。",

    "ledger.guide.over_budget": "本月已经超出预算 {amount}。看看下面哪个分类花得最多。",
    "ledger.guide.near_budget": "本月预算已用掉 {percent}%，接下来可以稍微省着点。",
    "ledger.guide.savings_at_risk": "离本月的储蓄目标还差 {amount}。",
    "ledger.guide.recurring": "固定支出一共 {amount}。可以看看有没有不再用的订阅。",
    "ledger.guide.dining": "在外吃饭花了 {amount}，占支出的 {percent}%。",
    "ledger.guide.no_income": "本月还没有记录收入。记上收入就能看到结余。",
    "ledger.guide.negative_balance": "本月花出去的比收进来的多 {amount}。",
    "ledger.guide.few_records": "目前只有 {n} 笔记录，记得越多，分析越准。",
    "ledger.guide.few_records.one": "目前只有 1 笔记录，记得越多，分析越准。",
    "ledger.guide.keep_going": "一切平稳。继续记账，趋势会慢慢显现出来。",

    "ledger.advice.title": "AI 理财建议",
    "ledger.advice.intro": "根据本月的数字，给你几条实用的小建议。",
    "ledger.advice.get": "请 AI 给点建议",
    "ledger.advice.thinking": "正在思考…",
    "ledger.advice.privacy": "只会发送各分类的总金额，不会发送商家名称、商品明细或备注。",
    "ledger.advice.disclaimer": "AI 给出的是一般性建议，不是专业理财意见。",
    "ledger.advice.noRecords": "请先记录一些本月的账目。",
    "ledger.advice.notConfigured": "AI 建议暂未开通。",
  },
  en: {
    "ledger.labels.title": "Photograph the nutrition tables of this shop's food",
    "ledger.labels.hint": "For packaged food, photograph the table on the back: calories, sugar, fat and salt go into the pantry for cooking and health checks.",
    "ledger.labels.shoot": "Photograph label",
    "ledger.labels.done": "Values known",
    "ledger.labels.saved": "Values and photo saved in the pantry",
    "ledger.trend.more": "Last month cost {amount} more than the month before (+{pct}%)",
    "ledger.trend.less": "Last month cost {amount} less than the month before (−{pct}%) — saved!",
    "ledger.trend.legend": "Orange dot: more than the month before; green dot: less.",
    "ledger.trend.saved": "Saved in these 12 months: {amount}",
    "ledger.trend.savedHint": "Saved = discounts on receipts + money back for returned bottles.",
    "ledger.savedToPantry": "Saved, and {n} foods are in the pantry. Photograph packaged food labels →",
    "ledger.ocr.intro": "Read the receipt on your phone: shop, date, total and every line. Free, and the photo stays on your phone. Check it before saving.",
    "ledger.ocr.read": "Read receipt",
    "ledger.ocr.reading": "Reading the receipt… {pct}%",
    "ledger.ocr.done": "Filled in from the receipt — please check the total, date and shop.",
    "ledger.pantry.on": "Also into the pantry: {names} ({n} in all)",
    "ledger.pantry.off": "Not into the pantry",
    "ledger.pantry.toggle": "Put the food on this receipt in the pantry when saving",
    "ledger.pantry.choose": "Choose which",
    "ledger.seePantry": "See pantry",
    "ledger.oneReceipt": "One receipt, one save: into the budget · bought items ticked off the shopping list · food into the pantry.",
    "ledger.detail.pantry": "Put in the pantry",
    "ledger.detail.pantryLeft": "{n} left",
    "ledger.detail.pantryGone": "used up",
    "ledger.ocr.retake": "Take it again",
    "ledger.ocr.aiFilling": "The AI is filling in the total and items the phone missed… You can check, change or save meanwhile.",
    "ledger.ocr.items": "{n} items",
    "ledger.ocr.sumOk": "The items add up to the total.",
    "ledger.ocr.saveHint": "All good? Just tap Save below.",
    "ledger.ocr.unreadable": "Couldn't read the text on this photo. Try again straight on and in good light, or fill in the details below.",
    "ledger.fileBy.label": "File by",
    "ledger.fileBy.date": "By date",
    "ledger.fileBy.store": "By shop",
    "ledger.fileBy.count": "{n}",
    "ledger.plan.title": "Planned or not",
    "ledger.plan.planned": "Planned on the list",
    "ledger.plan.discount": "Offers on the list",
    "ledger.plan.extra": "Added in the shop (unplanned)",
    "ledger.plan.offList": "Not on the list",
    "ledger.plan.saved": "Discounts on your receipts saved you {amount}.",
    "ledger.plan.basis": "Only the {n} receipts checked against your shopping list count.",
    "ledger.guide.unplanned": "{amount} ({percent}%) this month went on unplanned things. Writing your list before you go can save a lot.",
    "ledger.items.type": "Type of line {n}",
    "ledger.deposit.action": "Bottle return refund",
    "ledger.deposit.formTitle": "Add a bottle return",
    "ledger.deposit.intro": "Just enter the amount on the bottle-return slip and the shop. It counts as a refund and is taken off this month's spending.",
    "ledger.form.more": "More (payment, items, notes…)",
    "ledger.form.moreItems": "{n} items",
    "ledger.match.linkedSummary": "Checked against shopping list: {n} · Change",
    "ledger.match.collapsed": "Check against shopping list · optional",
    "ledger.match.empty": "There is nothing on your shopping list to check off right now.",
    "ledger.ai.unavailable": "AI reading isn't available right now. Please fill in the amount and shop below.",
    "ledger.ai.fillManually": "Please fill in the details below yourself.",
    "ledger.items.addReturn": "Bottle return",
    "ledger.line.item": "Product",
    "ledger.line.deposit": "Bottle deposit",
    "ledger.line.deposit_return": "Bottle return",
    "ledger.line.discount": "Discount",
    "ledger.deposit.paid": "Bottle deposit {amount}",
    "ledger.deposit.returned": "Bottle returns −{amount}",
    "ledger.match.title": "Check against your shopping list",
    "ledger.match.hint": "Tick the list items on this receipt. They are marked as bought and linked to this receipt.",
    "ledger.match.summary": "{bought} bought · {open} still on the list",
    "ledger.match.unplanned": "On the receipt but not on your list (unplanned):",
    "ledger.match.boughtEarlier": "Already ticked off",
    "ledger.match.onReceipt": "From your shopping list",
    "ledger.match.openList": "Open list",
    "ledger.ins.deposits": "Bottle returns",
    "ledger.ins.depositsSub": "Bottle deposit paid this month: {paid}",
    "ledger.title": "Household ledger",
    "ledger.tab.records": "Records",
    "ledger.tab.insights": "Insights",
    "ledger.spent": "Spent",
    "ledger.income": "Income",
    "ledger.balance": "Balance",
    "ledger.scan": "Scan receipt",
    "ledger.manual": "Add by hand",
    "ledger.addRecord": "Add a record",
    "ledger.listLabel": "Records",
    "ledger.search": "Search shop, item or note",
    "ledger.filters": "Filters",
    "ledger.clearFilters": "Clear filters",
    "ledger.clearSearch": "Clear search and filters",
    "ledger.hasPhoto": "Has a photo",
    "ledger.view": "View",
    "ledger.savedToast": "Record saved",

    "ledger.month.prev": "Previous month",
    "ledger.month.next": "Next month",
    "ledger.month.pick": "{month}, choose a month",
    "ledger.month.title": "Choose a month",
    "ledger.month.count": "{n} records",
    "ledger.month.count.one": "1 record",
    "ledger.month.none": "No records",

    "ledger.scope.month": "{n} records in {month}",
    "ledger.scope.month.one": "1 record in {month}",
    "ledger.scope.all": "{n} records across all months",
    "ledger.scope.all.one": "1 record across all months",
    "ledger.scope.searchAll": "Search all months",
    "ledger.scope.onlyMonth": "This month only",

    "ledger.empty.title": "Nothing recorded in {month}",
    "ledger.empty.body": "Photograph a receipt or add a cash purchase to get started.",
    "ledger.empty.noMatch": "Nothing matches",
    "ledger.empty.noMatchHint": "Try searching all months, or loosen the filters.",

    "ledger.kind.expense": "Expense",
    "ledger.kind.refund": "Refund",
    "ledger.kind.income": "Income",
    "ledger.kindPlural.expense": "Expenses",
    "ledger.kindPlural.refund": "Refunds",
    "ledger.kindPlural.income": "Income",
    "ledger.pay.card": "Card",
    "ledger.pay.cash": "Cash",
    "ledger.pay.transfer": "Transfer",
    "ledger.photo.with": "With photo",
    "ledger.photo.without": "Without photo",
    "ledger.trend.title": "Spending curve, last 12 months",
    "ledger.trend.all": "All spending",
    "ledger.trend.total": "{what}: {amount} over 12 months, {avg} a month on average",
    "ledger.trend.goods": "Things you bought to keep (clothes, household products, tools…) are sorted by kind in Home goods",
    "ledger.trip.title": "How this shopping adds up",
    "ledger.health.title": "How healthy was this shopping",
    "ledger.health.scoreLabel": "Health score",
    "ledger.health.explain": "{score}% of the money spent on food went to food that isn't high in sugar, salt or fat (typical values per 100 g).",
    "ledger.health.sugar": "high in sugar",
    "ledger.health.salt": "high in salt",
    "ledger.health.fat": "high in fat",
    "ledger.health.unknown": "{n} more are still being looked up; check back later for the full picture.",
    "ledger.trip.goods": "Products",
    "ledger.trip.deposit": "bottle deposit",
    "ledger.trip.returned": "bottle returns (on the receipt)",
    "ledger.trip.discount": "discounts",
    "ledger.trip.paid": "Paid",
    "ledger.trip.voucher": "bottle-return voucher",
    "ledger.trip.real": "Real cost",
    "ledger.trip.voucherLink": "Voucher {date} {amount}",
    "ledger.trip.hint": "Bottle-return money is taken off this shopping; the month totals already count it once, not twice.",
    "ledger.trip.usedOn": "This bottle-return voucher was used on the shopping at {store} on {date}: receipt {paid} → real cost {real}",

    "ledger.cat.groceries": "Groceries",
    "ledger.cat.dining": "Eating out",
    "ledger.cat.home": "Home",
    "ledger.cat.housing": "Housing",
    "ledger.cat.utilities": "Utilities",
    "ledger.cat.transport": "Transport",
    "ledger.cat.health": "Health",
    "ledger.cat.education": "Education",
    "ledger.cat.leisure": "Leisure",
    "ledger.cat.clothing": "Clothing",
    "ledger.cat.other": "Other",

    "ledger.form.newTitle.expense": "New expense",
    "ledger.form.newTitle.refund": "New refund",
    "ledger.form.newTitle.income": "New income",
    "ledger.form.editTitle": "Edit record",
    "ledger.form.photo": "Receipt photo",
    "ledger.form.scanHint": "Take a photo of the receipt and the app reads the shop, date, total and items — or just type them in.",

    "ledger.ai.intro": "Let AI read the shop, date, total and items. You check everything before saving.",
    "ledger.ai.read": "Read receipt with AI",
    "ledger.ai.reading": "Reading the receipt…",
    "ledger.ai.done": "Filled in from the receipt. Please check.",
    "ledger.ai.notEuro": "This receipt is in {currency}, not euros, so the amount was left empty. Enter the amount in euros yourself.",

    "ledger.field.kind": "Type",
    "ledger.field.amount": "Amount",
    "ledger.field.date": "Date",
    "ledger.field.store": "Shop or payee",
    "ledger.field.storePh": "e.g. Albert Heijn",
    "ledger.field.source": "Paid by / source",
    "ledger.field.sourcePh": "e.g. Salary, allowance",
    "ledger.field.category": "Category",
    "ledger.field.categoryAuto": "Suggested from the name. Change it if it's wrong.",
    "ledger.field.payment": "Payment",
    "ledger.field.essential": "Essential",
    "ledger.field.essentialHint": "Rent, groceries, insurance: things you can't skip.",
    "ledger.field.recurring": "Recurring",
    "ledger.field.recurringHint": "Comes back every month, like a subscription.",
    "ledger.field.reference": "Reference",
    "ledger.field.referenceHint": "Invoice or receipt number",
    "ledger.field.notes": "Notes",

    "ledger.items.title": "Items",
    "ledger.items.name": "Item {n}",
    "ledger.items.namePh": "Item",
    "ledger.items.price": "Price of item {n}",
    "ledger.items.remove": "Remove item {n}",
    "ledger.items.add": "Add item",
    "ledger.items.sum": "Items add up to {amount}",
    "ledger.items.diff": "{amount} off from the total",
    "ledger.items.useSum": "Use as total",
    "ledger.items.total": "Items total",

    "ledger.err.amount.required": "Enter an amount.",
    "ledger.err.amount.invalid": "Enter an amount like 12.50.",
    "ledger.err.amount.zero": "The amount must be more than zero.",
    "ledger.err.amount.too_large": "The amount can't be more than €1,000,000.",
    "ledger.err.date.required": "Pick a date.",
    "ledger.err.date.invalid": "That date doesn't exist.",
    "ledger.err.date.future": "The date can't be in the future.",
    "ledger.err.store.required": "Enter the shop or payee.",
    "ledger.err.store.too_long": "Keep it under 120 characters.",
    "ledger.err.item_name": "Give every item with a price a name.",
    "ledger.err.item_price": "Check the item prices, e.g. 2.49.",
    "ledger.err.fix": "Please fix the fields marked above.",

    "ledger.review.title": "Please check before saving",
    "ledger.review.duplicate": "There's already a record with the same shop, date, type and amount.",
    "ledger.review.same_photo": "This photo is already attached to another record.",
    "ledger.review.items_mismatch": "The items don't add up to the total.",
    "ledger.review.body": "If everything is right, you can save it anyway.",
    "ledger.review.check": "Go back",
    "ledger.review.saveAnyway": "Save anyway",

    "ledger.detail.title": "Record",
    "ledger.detail.inTrash": "This record is in the trash.",
    "ledger.detail.photo": "Photo",
    "ledger.detail.enlarge": "Enlarge photo",
    "ledger.detail.photoAlt": "Receipt from {store}",
    "ledger.detail.openPhoto": "Open full size",
    "ledger.detail.created": "Added {when}",
    "ledger.detail.updated": "changed {when}",
    "ledger.detail.trash": "Move to trash",

    "ledger.trash.title": "Trash",
    "ledger.trash.link": "Trash",
    "ledger.trash.intro": "Records in the trash don't count in your totals. Restore them or delete them for good.",
    "ledger.trash.empty": "The trash is empty",
    "ledger.trash.restored": "{store} is back in your records",
    "ledger.trash.deleted": "Deleted for good",
    "ledger.trash.confirmTitle": "Delete forever?",
    "ledger.trash.confirmBody": "{store} and its photo will be gone for good. This can't be undone.",

    "ledger.export.title": "Export",
    "ledger.export.intro": "Download your records as a spreadsheet. Excel files also include totals by month, shop and category.",
    "ledger.export.xlsxAll": "Excel · all records",
    "ledger.export.xlsxMonth": "Excel · {month}",

    "ledger.quarter.title": "Quarter overview",
    "ledger.quarter.pick": "Quarter",
    "ledger.quarter.label": "Q{q} {year}",
    "ledger.quarter.empty": "Nothing recorded in {quarter}",
    "ledger.quarter.months": "Months",
    "ledger.quarter.export": "Download quarter as Excel",
    "ledger.quarter.ready": "Last quarter's summary is ready",
    "ledger.quarter.readySub": "See where the money went in {quarter}.",

    "ledger.ins.metrics": "Month at a glance",
    "ledger.ins.net": "Net spending",
    "ledger.ins.refundsIncluded": "after {amount} in refunds",
    "ledger.ins.noIncomeYet": "No income recorded",
    "ledger.ins.vsPrev": "vs last month",
    "ledger.ins.prevWas": "Last month: {amount}",
    "ledger.ins.noPrev": "No records last month",
    "ledger.ins.records": "Records",
    "ledger.ins.withPhoto": "With a photo",
    "ledger.ins.guidance": "Tips for this month",
    "ledger.ins.categories": "Where the money went",
    "ledger.ins.merchants": "By shop",
    "ledger.ins.times": "{n} times",
    "ledger.ins.times.one": "once",
    "ledger.ins.through": "Through the month",
    "ledger.ins.days": "Days {from}–{to}",
    "ledger.ins.emptyTitle": "Nothing recorded in {month}",
    "ledger.ins.emptyBody": "Add a few records to see where your money goes.",

    "ledger.budget.title": "Budget",
    "ledger.budget.set": "Set budget",
    "ledger.budget.edit": "Change",
    "ledger.budget.none": "No budget for this month yet. Set a spending ceiling to see how you're doing.",
    "ledger.budget.used": "{percent}% used",
    "ledger.budget.over": "{amount} over budget",
    "ledger.budget.left": "{amount} left to spend",
    "ledger.budget.reserve": "Essentials reserve",
    "ledger.budget.essentialSpent": "{amount} spent on essentials",
    "ledger.budget.savings": "Savings goal",
    "ledger.budget.savingsNoIncome": "Add your income to track this",
    "ledger.budget.savingsOk": "On track",
    "ledger.budget.savingsShort": "{amount} short",
    "ledger.budget.sheetTitle": "Budget for {month}",
    "ledger.budget.intro": "Decide how much you want to spend this month. The reserve is the part set aside for essentials.",
    "ledger.budget.fromPrev": "Filled in from last month's budget.",
    "ledger.budget.ceiling": "Spending ceiling",
    "ledger.budget.ceilingHint": "The most you want to spend this month.",
    "ledger.budget.reserveHint": "The part of the ceiling kept for essentials like rent and groceries.",
    "ledger.budget.savingsHint": "What you'd like to have left over from your income.",
    "ledger.budget.remove": "Remove budget",
    "ledger.budget.err.ceiling_required": "Enter a spending ceiling.",
    "ledger.budget.err.ceiling_invalid": "The ceiling must be more than zero and at most €1,000,000.",
    "ledger.budget.err.reserve_invalid": "Check the reserve amount.",
    "ledger.budget.err.reserve_exceeds": "The reserve can't be more than the ceiling.",
    "ledger.budget.err.savings_invalid": "Check the savings amount.",

    "ledger.guide.over_budget": "You're {amount} over this month's budget. The categories below show where it went.",
    "ledger.guide.near_budget": "You've used {percent}% of this month's budget. Time to go a little easier.",
    "ledger.guide.savings_at_risk": "You're {amount} short of this month's savings goal.",
    "ledger.guide.recurring": "Recurring costs come to {amount}. Worth checking for subscriptions you no longer use.",
    "ledger.guide.dining": "Eating out came to {amount}, {percent}% of your spending.",
    "ledger.guide.no_income": "No income recorded this month. Add it to see your balance.",
    "ledger.guide.negative_balance": "{amount} more went out than came in this month.",
    "ledger.guide.few_records": "Only {n} records so far. The picture gets clearer as you add more.",
    "ledger.guide.few_records.one": "Only 1 record so far. The picture gets clearer as you add more.",
    "ledger.guide.keep_going": "Looking steady. Keep recording and trends will show up here.",

    "ledger.advice.title": "Advice from AI",
    "ledger.advice.intro": "Get a few practical suggestions based on this month's figures.",
    "ledger.advice.get": "Get advice from AI",
    "ledger.advice.thinking": "Thinking…",
    "ledger.advice.privacy": "Only totals per category are sent — never shop names, items or notes.",
    "ledger.advice.disclaimer": "These are general tips from AI, not professional financial advice.",
    "ledger.advice.noRecords": "Add some records for this month first.",
    "ledger.advice.notConfigured": "AI advice isn't switched on yet.",
  },
  nl: {
    "ledger.labels.title": "Fotografeer de voedingstabellen van deze boodschappen",
    "ledger.labels.hint": "Fotografeer bij verpakt eten de tabel op de achterkant: calorieën, suiker, vet en zout gaan in de voorraad, voor koken en gezondheid.",
    "ledger.labels.shoot": "Etiket fotograferen",
    "ledger.labels.done": "Waarden bekend",
    "ledger.labels.saved": "Waarden en foto opgeslagen in de voorraad",
    "ledger.trend.more": "Vorige maand kostte {amount} meer dan de maand ervoor (+{pct}%)",
    "ledger.trend.less": "Vorige maand kostte {amount} minder dan de maand ervoor (−{pct}%) — bespaard!",
    "ledger.trend.legend": "Oranje stip: meer dan de maand ervoor; groene stip: minder.",
    "ledger.trend.saved": "Bespaard in deze 12 maanden: {amount}",
    "ledger.trend.savedHint": "Bespaard = kortingen op bonnen + statiegeld terug.",
    "ledger.savedToPantry": "Opgeslagen, {n} producten in de voorraad. Fotografeer etiketten van verpakt eten →",
    "ledger.ocr.intro": "Lees de kassabon op je telefoon: winkel, datum, totaal en elke regel. Gratis, en de foto blijft op je telefoon. Controleer het voor je opslaat.",
    "ledger.ocr.read": "Bon lezen",
    "ledger.ocr.reading": "Bon wordt gelezen… {pct}%",
    "ledger.ocr.done": "Ingevuld vanaf de bon — controleer totaal, datum en winkel.",
    "ledger.pantry.on": "Ook in de voorraad: {names} ({n} in totaal)",
    "ledger.pantry.off": "Niet in de voorraad",
    "ledger.pantry.toggle": "Het eten van dit bonnetje bij het opslaan in de voorraad zetten",
    "ledger.pantry.choose": "Kies welke",
    "ledger.seePantry": "Bekijk voorraad",
    "ledger.oneReceipt": "Eén bonnetje, één keer opslaan: in het huishoudboekje · gekochte dingen afgevinkt op de lijst · eten in de voorraad.",
    "ledger.detail.pantry": "In de voorraad gezet",
    "ledger.detail.pantryLeft": "nog {n}",
    "ledger.detail.pantryGone": "op",
    "ledger.ocr.retake": "Opnieuw fotograferen",
    "ledger.ocr.aiFilling": "De AI vult het totaal en de artikelen aan die de telefoon miste… Je kunt intussen controleren, aanpassen of opslaan.",
    "ledger.ocr.items": "{n} artikelen",
    "ledger.ocr.sumOk": "De artikelen tellen op tot het totaal.",
    "ledger.ocr.saveHint": "Klopt het? Tik dan hieronder op Opslaan.",
    "ledger.ocr.unreadable": "De tekst op deze foto kon niet gelezen worden. Probeer het recht van voren en met goed licht, of vul het hieronder zelf in.",
    "ledger.fileBy.label": "Ordenen op",
    "ledger.fileBy.date": "Op datum",
    "ledger.fileBy.store": "Per winkel",
    "ledger.fileBy.count": "{n}",
    "ledger.plan.title": "Gepland of niet",
    "ledger.plan.planned": "Gepland op de lijst",
    "ledger.plan.discount": "Aanbiedingen op de lijst",
    "ledger.plan.extra": "In de winkel toegevoegd (niet gepland)",
    "ledger.plan.offList": "Niet op de lijst",
    "ledger.plan.saved": "De kortingen op je bonnen schelen {amount}.",
    "ledger.plan.basis": "Alleen de {n} bonnen die met je boodschappenlijst zijn vergeleken tellen mee.",
    "ledger.guide.unplanned": "Deze maand ging {amount} ({percent}%) naar ongeplande dingen. Je lijst maken voor je gaat scheelt veel.",
    "ledger.items.type": "Soort van regel {n}",
    "ledger.deposit.action": "Statiegeld terug",
    "ledger.deposit.formTitle": "Statiegeld terug invoeren",
    "ledger.deposit.intro": "Vul alleen het bedrag van de statiegeldbon en de winkel in. Het telt als terugbetaling en gaat van je uitgaven van deze maand af.",
    "ledger.form.more": "Meer (betaling, artikelen, notities…)",
    "ledger.form.moreItems": "{n} artikelen",
    "ledger.match.linkedSummary": "Vergeleken met boodschappenlijst: {n} · Wijzigen",
    "ledger.match.collapsed": "Vergelijken met boodschappenlijst · optioneel",
    "ledger.match.empty": "Er staat nu niets op je boodschappenlijst om af te vinken.",
    "ledger.ai.unavailable": "AI-herkenning is nu niet beschikbaar. Vul hieronder zelf het bedrag en de winkel in.",
    "ledger.ai.fillManually": "Vul de gegevens hieronder zelf in.",
    "ledger.items.addReturn": "Statiegeld retour",
    "ledger.line.item": "Product",
    "ledger.line.deposit": "Statiegeld",
    "ledger.line.deposit_return": "Statiegeld retour",
    "ledger.line.discount": "Korting",
    "ledger.deposit.paid": "Statiegeld {amount}",
    "ledger.deposit.returned": "Statiegeld retour −{amount}",
    "ledger.match.title": "Vergelijk met je boodschappenlijst",
    "ledger.match.hint": "Vink aan wat van je lijstje op deze bon staat. Die items worden afgevinkt en aan deze bon gekoppeld.",
    "ledger.match.summary": "{bought} gekocht · {open} nog op de lijst",
    "ledger.match.unplanned": "Op de bon maar niet op je lijstje (ongepland):",
    "ledger.match.boughtEarlier": "Al afgevinkt",
    "ledger.match.onReceipt": "Van je boodschappenlijst",
    "ledger.match.openList": "Lijst openen",
    "ledger.ins.deposits": "Statiegeld retour",
    "ledger.ins.depositsSub": "Deze maand betaald aan statiegeld: {paid}",
    "ledger.title": "Huishoudboekje",
    "ledger.tab.records": "Uitgaven",
    "ledger.tab.insights": "Overzicht",
    "ledger.spent": "Uitgegeven",
    "ledger.income": "Inkomsten",
    "ledger.balance": "Saldo",
    "ledger.scan": "Bonnetje scannen",
    "ledger.manual": "Zelf invoeren",
    "ledger.addRecord": "Iets toevoegen",
    "ledger.listLabel": "Boekingen",
    "ledger.search": "Zoek op winkel, product of notitie",
    "ledger.filters": "Filters",
    "ledger.clearFilters": "Filters wissen",
    "ledger.clearSearch": "Zoeken en filters wissen",
    "ledger.hasPhoto": "Met foto",
    "ledger.view": "Bekijken",
    "ledger.savedToast": "Opgeslagen",

    "ledger.month.prev": "Vorige maand",
    "ledger.month.next": "Volgende maand",
    "ledger.month.pick": "{month}, kies een maand",
    "ledger.month.title": "Kies een maand",
    "ledger.month.count": "{n} boekingen",
    "ledger.month.count.one": "1 boeking",
    "ledger.month.none": "Geen boekingen",

    "ledger.scope.month": "{n} boekingen in {month}",
    "ledger.scope.month.one": "1 boeking in {month}",
    "ledger.scope.all": "{n} boekingen in alle maanden",
    "ledger.scope.all.one": "1 boeking in alle maanden",
    "ledger.scope.searchAll": "Zoek in alle maanden",
    "ledger.scope.onlyMonth": "Alleen deze maand",

    "ledger.empty.title": "Nog niets in {month}",
    "ledger.empty.body": "Maak een foto van een bonnetje of voer een contante aankoop in om te beginnen.",
    "ledger.empty.noMatch": "Niets gevonden",
    "ledger.empty.noMatchHint": "Zoek in alle maanden, of maak de filters ruimer.",

    "ledger.kind.expense": "Uitgave",
    "ledger.kind.refund": "Terugbetaling",
    "ledger.kind.income": "Inkomsten",
    "ledger.kindPlural.expense": "Uitgaven",
    "ledger.kindPlural.refund": "Terugbetalingen",
    "ledger.kindPlural.income": "Inkomsten",
    "ledger.pay.card": "Pin/kaart",
    "ledger.pay.cash": "Contant",
    "ledger.pay.transfer": "Overboeking",
    "ledger.photo.with": "Met foto",
    "ledger.photo.without": "Zonder foto",
    "ledger.trend.title": "Uitgavencurve, laatste 12 maanden",
    "ledger.trend.all": "Alle uitgaven",
    "ledger.trend.total": "{what}: {amount} in 12 maanden, gemiddeld {avg} per maand",
    "ledger.trend.goods": "Gekochte spullen (kleding, huishoudproducten, gereedschap…) staan per soort bij Spullen in huis",
    "ledger.trip.title": "Zo komt deze boodschap uit",
    "ledger.health.title": "Hoe gezond was deze boodschap",
    "ledger.health.scoreLabel": "Gezondheidsscore",
    "ledger.health.explain": "{score}% van het geld voor eten ging naar eten dat niet veel suiker, zout of vet bevat (gangbare waarden per 100 g).",
    "ledger.health.sugar": "veel suiker",
    "ledger.health.salt": "veel zout",
    "ledger.health.fat": "veel vet",
    "ledger.health.unknown": "Nog {n} worden opgezocht; kijk later nog eens voor het hele beeld.",
    "ledger.trip.goods": "Producten",
    "ledger.trip.deposit": "statiegeld",
    "ledger.trip.returned": "statiegeld retour (op de bon)",
    "ledger.trip.discount": "korting",
    "ledger.trip.paid": "Betaald",
    "ledger.trip.voucher": "statiegeldbon",
    "ledger.trip.real": "Werkelijk uitgegeven",
    "ledger.trip.voucherLink": "Bon {date} {amount}",
    "ledger.trip.hint": "Het statiegeld gaat van deze boodschappen af; in de maandtotalen telt het al één keer mee, niet twee keer.",
    "ledger.trip.usedOn": "Deze statiegeldbon is verrekend met de boodschappen bij {store} op {date}: bon {paid} → werkelijk {real}",

    "ledger.cat.groceries": "Boodschappen",
    "ledger.cat.dining": "Uit eten",
    "ledger.cat.home": "Huishouden",
    "ledger.cat.housing": "Wonen",
    "ledger.cat.utilities": "Energie & internet",
    "ledger.cat.transport": "Vervoer",
    "ledger.cat.health": "Gezondheid",
    "ledger.cat.education": "Onderwijs",
    "ledger.cat.leisure": "Vrije tijd",
    "ledger.cat.clothing": "Kleding",
    "ledger.cat.other": "Overig",

    "ledger.form.newTitle.expense": "Nieuwe uitgave",
    "ledger.form.newTitle.refund": "Nieuwe terugbetaling",
    "ledger.form.newTitle.income": "Nieuwe inkomsten",
    "ledger.form.editTitle": "Boeking bewerken",
    "ledger.form.photo": "Foto van het bonnetje",
    "ledger.form.scanHint": "Maak een foto van het bonnetje, dan leest de app winkel, datum, bedrag en artikelen. Zelf typen kan ook.",

    "ledger.ai.intro": "Laat AI de winkel, datum, het totaal en de producten aflezen. Jij controleert alles voordat je opslaat.",
    "ledger.ai.read": "Bonnetje laten lezen door AI",
    "ledger.ai.reading": "Bonnetje wordt gelezen…",
    "ledger.ai.done": "Ingevuld vanaf het bonnetje. Controleer het even.",
    "ledger.ai.notEuro": "Dit bonnetje is in {currency}, niet in euro's. Het bedrag is daarom leeg gelaten; vul het zelf in euro's in.",

    "ledger.field.kind": "Soort",
    "ledger.field.amount": "Bedrag",
    "ledger.field.date": "Datum",
    "ledger.field.store": "Winkel of ontvanger",
    "ledger.field.storePh": "bijv. Albert Heijn",
    "ledger.field.source": "Betaald door / bron",
    "ledger.field.sourcePh": "bijv. Salaris, toeslag",
    "ledger.field.category": "Categorie",
    "ledger.field.categoryAuto": "Voorgesteld op basis van de naam. Pas het aan als het niet klopt.",
    "ledger.field.payment": "Betaald met",
    "ledger.field.essential": "Noodzakelijk",
    "ledger.field.essentialHint": "Huur, boodschappen, verzekering: dingen die je niet kunt overslaan.",
    "ledger.field.recurring": "Vaste last",
    "ledger.field.recurringHint": "Komt elke maand terug, zoals een abonnement.",
    "ledger.field.reference": "Kenmerk",
    "ledger.field.referenceHint": "Factuur- of bonnummer",
    "ledger.field.notes": "Notities",

    "ledger.items.title": "Producten",
    "ledger.items.name": "Product {n}",
    "ledger.items.namePh": "Product",
    "ledger.items.price": "Prijs van product {n}",
    "ledger.items.remove": "Product {n} verwijderen",
    "ledger.items.add": "Product toevoegen",
    "ledger.items.sum": "Producten samen {amount}",
    "ledger.items.diff": "{amount} verschil met het totaal",
    "ledger.items.useSum": "Als totaal gebruiken",
    "ledger.items.total": "Totaal producten",

    "ledger.err.amount.required": "Vul een bedrag in.",
    "ledger.err.amount.invalid": "Vul een bedrag in zoals 12,50.",
    "ledger.err.amount.zero": "Het bedrag moet groter zijn dan nul.",
    "ledger.err.amount.too_large": "Het bedrag mag niet hoger zijn dan € 1.000.000.",
    "ledger.err.date.required": "Kies een datum.",
    "ledger.err.date.invalid": "Die datum bestaat niet.",
    "ledger.err.date.future": "De datum kan niet in de toekomst liggen.",
    "ledger.err.store.required": "Vul de winkel of ontvanger in.",
    "ledger.err.store.too_long": "Maximaal 120 tekens.",
    "ledger.err.item_name": "Geef elk product met een prijs ook een naam.",
    "ledger.err.item_price": "Controleer de productprijzen, bijv. 2,49.",
    "ledger.err.fix": "Pas eerst de gemarkeerde velden aan.",

    "ledger.review.title": "Even controleren",
    "ledger.review.duplicate": "Er is al een boeking met dezelfde winkel, datum, soort en hetzelfde bedrag.",
    "ledger.review.same_photo": "Deze foto hoort al bij een andere boeking.",
    "ledger.review.items_mismatch": "De producten tellen niet op tot het totaal.",
    "ledger.review.body": "Klopt alles? Dan kun je toch opslaan.",
    "ledger.review.check": "Terug",
    "ledger.review.saveAnyway": "Toch opslaan",

    "ledger.detail.title": "Boeking",
    "ledger.detail.inTrash": "Deze boeking staat in de prullenbak.",
    "ledger.detail.photo": "Foto",
    "ledger.detail.enlarge": "Foto vergroten",
    "ledger.detail.photoAlt": "Bonnetje van {store}",
    "ledger.detail.openPhoto": "Op ware grootte openen",
    "ledger.detail.created": "Toegevoegd {when}",
    "ledger.detail.updated": "gewijzigd {when}",
    "ledger.detail.trash": "Naar prullenbak",

    "ledger.trash.title": "Prullenbak",
    "ledger.trash.link": "Prullenbak",
    "ledger.trash.intro": "Boekingen in de prullenbak tellen niet mee. Zet ze terug of verwijder ze definitief.",
    "ledger.trash.empty": "De prullenbak is leeg",
    "ledger.trash.restored": "{store} staat weer tussen je boekingen",
    "ledger.trash.deleted": "Definitief verwijderd",
    "ledger.trash.confirmTitle": "Definitief verwijderen?",
    "ledger.trash.confirmBody": "{store} en de foto worden definitief verwijderd. Dit kun je niet ongedaan maken.",

    "ledger.export.title": "Exporteren",
    "ledger.export.intro": "Download je boekingen als spreadsheet. Excel-bestanden bevatten ook totalen per maand, winkel en categorie.",
    "ledger.export.xlsxAll": "Excel · alle boekingen",
    "ledger.export.xlsxMonth": "Excel · {month}",

    "ledger.quarter.title": "Kwartaaloverzicht",
    "ledger.quarter.pick": "Kwartaal",
    "ledger.quarter.label": "{q}e kwartaal {year}",
    "ledger.quarter.empty": "Niets geboekt in het {quarter}",
    "ledger.quarter.months": "Maanden",
    "ledger.quarter.export": "Kwartaal downloaden als Excel",
    "ledger.quarter.ready": "Het overzicht van vorig kwartaal staat klaar",
    "ledger.quarter.readySub": "Bekijk waar het geld in het {quarter} naartoe ging.",

    "ledger.ins.metrics": "De maand in het kort",
    "ledger.ins.net": "Netto uitgegeven",
    "ledger.ins.refundsIncluded": "na {amount} aan terugbetalingen",
    "ledger.ins.noIncomeYet": "Nog geen inkomsten ingevoerd",
    "ledger.ins.vsPrev": "t.o.v. vorige maand",
    "ledger.ins.prevWas": "Vorige maand: {amount}",
    "ledger.ins.noPrev": "Geen boekingen vorige maand",
    "ledger.ins.records": "Boekingen",
    "ledger.ins.withPhoto": "Met foto",
    "ledger.ins.guidance": "Tips voor deze maand",
    "ledger.ins.categories": "Waar het geld naartoe ging",
    "ledger.ins.merchants": "Per winkel",
    "ledger.ins.times": "{n} keer",
    "ledger.ins.times.one": "1 keer",
    "ledger.ins.through": "Verloop van de maand",
    "ledger.ins.days": "Dag {from}–{to}",
    "ledger.ins.emptyTitle": "Nog niets in {month}",
    "ledger.ins.emptyBody": "Voer een paar boekingen in om te zien waar je geld naartoe gaat.",

    "ledger.budget.title": "Budget",
    "ledger.budget.set": "Budget instellen",
    "ledger.budget.edit": "Wijzigen",
    "ledger.budget.none": "Nog geen budget voor deze maand. Stel een maximum in om te zien hoe je ervoor staat.",
    "ledger.budget.used": "{percent}% gebruikt",
    "ledger.budget.over": "{amount} over het budget",
    "ledger.budget.left": "Nog {amount} te besteden",
    "ledger.budget.reserve": "Reserve voor vaste kosten",
    "ledger.budget.essentialSpent": "{amount} uitgegeven aan noodzakelijke dingen",
    "ledger.budget.savings": "Spaardoel",
    "ledger.budget.savingsNoIncome": "Voer je inkomsten in om dit te volgen",
    "ledger.budget.savingsOk": "Op schema",
    "ledger.budget.savingsShort": "Nog {amount} te gaan",
    "ledger.budget.sheetTitle": "Budget voor {month}",
    "ledger.budget.intro": "Bepaal hoeveel je deze maand wilt uitgeven. De reserve is het deel voor noodzakelijke uitgaven.",
    "ledger.budget.fromPrev": "Ingevuld met het budget van vorige maand.",
    "ledger.budget.ceiling": "Maximaal uitgeven",
    "ledger.budget.ceilingHint": "Het meeste dat je deze maand wilt uitgeven.",
    "ledger.budget.reserveHint": "Het deel van het maximum voor dingen als huur en boodschappen.",
    "ledger.budget.savingsHint": "Wat je van je inkomen wilt overhouden.",
    "ledger.budget.remove": "Budget verwijderen",
    "ledger.budget.err.ceiling_required": "Vul een maximum in.",
    "ledger.budget.err.ceiling_invalid": "Het maximum moet groter zijn dan nul en mag niet boven € 1.000.000 komen.",
    "ledger.budget.err.reserve_invalid": "Controleer het bedrag van de reserve.",
    "ledger.budget.err.reserve_exceeds": "De reserve mag niet hoger zijn dan het maximum.",
    "ledger.budget.err.savings_invalid": "Controleer het spaarbedrag.",

    "ledger.guide.over_budget": "Je zit {amount} boven het budget van deze maand. Hieronder zie je waar het naartoe ging.",
    "ledger.guide.near_budget": "Je hebt {percent}% van je budget gebruikt. Tijd om het wat rustiger aan te doen.",
    "ledger.guide.savings_at_risk": "Je komt {amount} tekort voor je spaardoel van deze maand.",
    "ledger.guide.recurring": "Vaste lasten: {amount}. Kijk eens of er abonnementen tussen zitten die je niet meer gebruikt.",
    "ledger.guide.dining": "Uit eten: {amount}, {percent}% van je uitgaven.",
    "ledger.guide.no_income": "Nog geen inkomsten ingevoerd deze maand. Voeg ze toe om je saldo te zien.",
    "ledger.guide.negative_balance": "Er ging deze maand {amount} meer uit dan er binnenkwam.",
    "ledger.guide.few_records": "Nog maar {n} boekingen. Hoe meer je invoert, hoe duidelijker het beeld.",
    "ledger.guide.few_records.one": "Nog maar 1 boeking. Hoe meer je invoert, hoe duidelijker het beeld.",
    "ledger.guide.keep_going": "Ziet er rustig uit. Blijf invoeren, dan worden trends hier zichtbaar.",

    "ledger.advice.title": "Advies van AI",
    "ledger.advice.intro": "Krijg een paar praktische tips op basis van de cijfers van deze maand.",
    "ledger.advice.get": "Advies vragen aan AI",
    "ledger.advice.thinking": "Even nadenken…",
    "ledger.advice.privacy": "Alleen totalen per categorie worden verstuurd, nooit winkelnamen, producten of notities.",
    "ledger.advice.disclaimer": "Dit zijn algemene tips van AI, geen professioneel financieel advies.",
    "ledger.advice.noRecords": "Voer eerst een paar boekingen in voor deze maand.",
    "ledger.advice.notConfigured": "Advies van AI is nog niet ingeschakeld.",
  },
} satisfies Dict;
